if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
       this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          return_to: this.querySelector('input[name="return_to"]'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const url = new URL(this.elements.return_to.value, window.location.origin);
        var return_to = this.elements.return_to.value;
        if (url.pathname.includes("breyers-recipe-detailed")) {
          const id = url.searchParams.get("id");
          url.searchParams.set("id", this.recipeSwap(id, this.elements.input.value));
          return_to = url.pathname + url.search;
        }
        this.elements.return_to.value = return_to;
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
      recipeSwap(id, language) {
        this.forward = {
          "98767": "73757",
          "98773": "73773",
          "99117": "74453",
          "99125": "73252",
          "99138": "74472",
          "99137": "74471",
          "99136": "109489",
          "99135": "109488",
          "99134": "109487",
          "99133": "74468",
          "99131": "73250",
          "99130": "73248",
          "99129": "73246",
          "99128": "109486",
          "99126": "74463",
          "99124": "73231",
          "99118": "73213",
          "99109": "73196",
          "99108": "73195",
          "99107": "109483",
          "99105": "74443",
          "99104": "73186",
          "99102": "73179",
          "99101": "73184",
          "98843": "73887",
          "98840": "73883",
          "98839": "73881",
          "98774": "73774",
          "98772": "73766",
          "98770": "74668",
          "95198": "68179",
          "95196": "68175",
          "95195": "68173",
          "95194": "68171",
          "95193": "68169",
          "95192": "68167",
          "95191": "68165",
          "95190": "68163",
          "95188": "68159",
          "95187": "68157",
          "95184": "68151",
          "95182": "68147",
          "95180": "68143",
          "95179": "68141",
          "95178": "68139",
          "95177": "68137",
          "95175": "68133",
          "95174": "68131",
          "95173": "68129",
          "95171": "68125",
          "95169": "68121",
          "95167": "68117",
          "95161": "68107",
          "95160": "68105",
          "95159": "68099",
          "95158": "68097",
          "95157": "68095",
          "95156": "74808",
          "95155": "68093",
          "95152": "68087",
          "95151": "68085",
          "95148": "68079",
          "95147": "68077",
          "95146": "68075",
          "95145": "68073",
          "95143": "68069",
          "95142": "68067",
          "95140": "68061",
          "95139": "68059",
          "95135": "68050",
          "95134": "68048",
        };
        this.reverse = Object.fromEntries(
          Object.entries(this.forward).map(([k, v]) => [v, k])
        );
        return language == "en" ? this.forward[id] || id  : this.reverse[id] || id;
      }
    }
  );
}
